import { render, staticRenderFns } from "./page-header-logo.vue?vue&type=template&id=584b249c&scoped=true"
import script from "./page-header-logo.vue?vue&type=script&lang=js"
export * from "./page-header-logo.vue?vue&type=script&lang=js"
import style0 from "./page-header-logo.vue?vue&type=style&index=0&id=584b249c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b249c",
  null
  
)

export default component.exports